import React, { useState, useContext, useReducer } from 'react';
import { FaFemale, FaMale } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import { Slider } from '@material-tailwind/react';
import GlobalContext, { SET_FORM_VALUES } from '../GlobalProvider';
import '../../male-icons.css'; // Import default male icons style
import '../../female-icons.css'; // Import default female icons style

function StepOne({ currentStep, setCurrentStep }) {
  const { state, dispatch } = useContext(GlobalContext);
  const { formValues } = state;

  const [maleSelected, setMaleSelected] = useState(false);
  const [femaleSelected, setFemaleSelected] = useState(false);

  const handleMaleClick = () => {
    setMaleSelected(true); 
    setFemaleSelected(false);
  };

  const handleFemaleClick = () => {
    setMaleSelected(false);
    setFemaleSelected(true);
  };

  const handleCurrentAgeChange = (e) => {
    let updatedValue = parseInt(e.target.value);
    let retirementVal = formValues.retirement;
    if (updatedValue < 18) {
      updatedValue = 18;
    } else {
      updatedValue = Math.min(updatedValue, retirementVal);
    }
    setCurrentAge(updatedValue);
    dispatch({ type: SET_FORM_VALUES, payload: { current: updatedValue } });
  };

  const handleRetirementAgeChange = (e) => {
    const value = e.target.value;
    const updatedValue = Math.max(parseInt(value), formValues.current);

    dispatch({
      type: SET_FORM_VALUES,
      // payload: { retirement: newRetirementAge },
      payload: { retirement: updatedValue },
    });
  };

  const handleCurrentTextInputChange = (e) => {
    const updatedValue = parseInt(e.target.value);
    if (!isNaN(updatedValue) && updatedValue >= 18 && updatedValue <= formValues.retirement) {
      setCurrentAge(updatedValue);
      dispatch({ type: SET_FORM_VALUES, payload: { current: updatedValue } });
    }
  };

  const handleRetirementTextInputChange = (e) => {
    const value = e.target.value;

    if (!isNaN(value) && parseInt(value) >= formValues.current && parseInt(value) <= 100) {
      const updatedValue = Math.max(parseInt(value), formValues.current);
      dispatch({
        type: SET_FORM_VALUES,
        // payload: { retirement: newRetirementAge },
        payload: { retirement: updatedValue },
      });
    }
  };

  const [retirement, setRetirementAge] = useState(formValues.retirement); // Use formValues for initial state
  const [retireInput, setRetireInput] = useState(0)
  const [current, setCurrentAge] = useState(formValues.current); // Use formValues for initial state

  return (
    <>
      <div className="text-center font-display font-medium mb-5">
        <p>What is your gender?</p>
      </div>
      <div className="flex justify-between items-end border-none">
        <div
          onClick={handleMaleClick}
          style={{ cursor: 'pointer', color: maleSelected ? 'green' : 'transparent', width:'1.5rem' }}
        >
          <IconContext.Provider value={{ className: 'male-icons', style: { marginRight: '8px', color: maleSelected ? 'green' : 'lightblue' } }}>
            <FaMale />
          </IconContext.Provider>
          <big className='font-light'>Male</big>
        </div>
        {/* icons separated */}
        <div
          onClick={handleFemaleClick}
          style={{ cursor: 'pointer', color: femaleSelected ? 'green' : 'transparent', width:'1.5rem'}}
        >
          <IconContext.Provider value={{ className: 'female-icons', style: { marginLeft: '8px', color: femaleSelected ? 'green' : 'palevioletred' } }}>
            <FaFemale />
          </IconContext.Provider>
          <big className='font-light -ml-12'>Female</big>
        </div>
      </div>
      <hr className="my-0 mx-auto w-full border-t-1 border-red-950 m-o p-0" />
      <br className="h-4" />
      <div className="flex flex-col gap-4">
        <div className="w-full">
          <h4>Retirement Age</h4>
          <Slider
            className='flex mt-4 mb-2'
            color="red"
            size="sm"
            min={0}
            max={100}
            defaultValue={formValues.retirement}
            value={formValues.retirement}
            onChange={handleRetirementAgeChange}
          />
        </div>
        <div className="text-center">
          <input
            type="text"
            placeholder={formValues.retirement}
            defaultValue={formValues.retirement}
            className="styled-input text-center text-red-900"
            onChange={handleRetirementTextInputChange}
            // readOnly={false}
          />
        </div>

        <div className="w-full">
          <h4>Current Age</h4>
          <Slider
            className='flex mt-4 mb-2'
            color="red"
            size="sm"
            min={0}
            max={100}
            defaultValue={formValues.current}
            value={formValues.current}
            onChange={handleCurrentAgeChange}
          />
        </div>

        <div className="text-center mb-4">
          <input
            type="text"
            placeholder={formValues.current}
            defaultValue={formValues.current}
            className="styled-input text-center text-red-900"
            onChange={handleCurrentTextInputChange}
          />
        </div>
      </div>
    </>
  );
}

export default StepOne;
